import { toast, ToastOptions } from 'react-toastify';
import i18n from '../i18n';

// Default toast options with custom styling
const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  className:
    'bg-black/90 backdrop-blur-sm border border-white/20 rounded-lg text-white font-[NapsterSans] text-sm',
  progressClassName:
    'bg-gradient-to-r from-[rgba(0,255,255,0.8)] to-[rgba(255,4,255,0.8)]',
};

// Custom toast functions
export const showToast = {
  success: (message: string, options?: ToastOptions) => {
    toast.success(message, { ...defaultOptions, ...options });
  },

  error: (message: string, options?: ToastOptions) => {
    toast.error(message, { ...defaultOptions, ...options });
  },

  info: (message: string, options?: ToastOptions) => {
    toast.info(message, { ...defaultOptions, ...options });
  },

  warning: (message: string, options?: ToastOptions) => {
    toast.warning(message, { ...defaultOptions, ...options });
  },

  // Custom favorite-specific toasts with icons
  liked: (albumName?: string) => {
    const message = albumName
      ? i18n.t('toast.liked', { name: albumName })
      : i18n.t('toast.likedDefault');
    toast.success(message, {
      ...defaultOptions,
      autoClose: 1500,
    });
  },

  unliked: (albumName?: string) => {
    const message = albumName
      ? i18n.t('toast.unliked', { name: albumName })
      : i18n.t('toast.unlikedDefault');
    toast.info(message, {
      ...defaultOptions,
      autoClose: 1500,
    });
  },
};

export default showToast;
